<template>
  <v-container>
    <v-flex xs12 sm12 md12 lg12 xl12>
      <v-stepper v-model="numeroScheda" non-linear>
        <v-stepper-header>
          <v-stepper-step editable :complete="numeroScheda > 1" step="1"
            >Dati</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step :complete="numeroScheda > 2" step="2" editable
            >Configurazione</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step editable :complete="numeroScheda > 3" step="3"
            >Regolarità e funzionalità</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step editable step="4" :complete="numeroScheda > 4"
            >Stato di conservazione</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step editable step="5" :complete="numeroScheda > 5"
            >Esito</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step editable step="6" :complete="numeroScheda > 6"
            >Firme</v-stepper-step
          >
        </v-stepper-header>
        <v-stepper-items>
          <v-form v-model="form" ref="validForm">
            <!--Prima scheda - Dati generali sull'impianto-->
            <v-stepper-content step="1">
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-col xs6 sm6 md6 lg6 xl6>
                  <DataPicker
                    label="Data verbale"
                    v-model="verbale.dataVerifica"
                    outlined
                  ></DataPicker>
                </v-col>
                <v-col xs6 sm6 md6 lg6 xl6>
                  <v-select
                    label="Verificatore"
                    outlined
                    :items="listaVerificatori"
                    item-text="name"
                    item-value="ad_user_id"
                    v-model="verbale.ad_userverificatore_id"
                    no-data-text
                    :rules="[rules.select]"
                  ></v-select>
                </v-col>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-col xs12 sm12 md12 lg12 xl12>
                  <v-select
                    outlined
                    :items="tipiVerifica"
                    v-model="verbale.tipoVerifica"
                    no-data-text="Nessun dato"
                    item-text="name"
                    item-value="id"
                    label="Tipo Verifica"
                    :rules="[rules.select]"
                  ></v-select>
                </v-col>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12 align-center>
                <v-col>
                  <v-text-field
                    label="Matricola"
                    outlined
                    v-model="verbale.matricola"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Installatore"
                    outlined
                    v-model="verbale.installatore"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-col>
                  <v-text-field
                    label="Installato/utilizzato nel cantiere/stabilimento della ditta"
                    outlined
                    v-model="verbale.ditta"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-col xs4 sm4 md4 lg4 xl4>
                  <v-text-field
                    label="Comune"
                    outlined
                    v-model="verbale.comuneDitta"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col xs4 sm4 md4 lg4 xl4>
                  <v-text-field
                    label="Via"
                    outlined
                    v-model="verbale.viaDitta"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <!--<v-col xs1 sm1 md1 lg1 xl1>
                  <v-text-field
                    label="Numero civico"
                    outlined
                    v-model="verbale.numeroCivicoDitta"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>-->
              </v-flex>
            </v-stepper-content>
            <!--Fine prima scheda-->

            <!--Seconda scheda - Configurazione e dati tecnici rilevati al momento della verifica-->

            <v-stepper-content step="2">
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <editableTable
                  :headers="headersGeneratori"
                  v-model="verbale.generatori"
                />
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-textarea
                  outlined
                  label="Matricole dei vasi collaudati"
                  v-model="verbale.matricoleVasi"
                  :rules="[rules.required]"
                ></v-textarea>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-checkbox
                  v-model="verbale.rispettoIspesl"
                  label="Gli impianti rispettano, qualora non certificati come insiemi, le prescrizioni della Raccolta R dell'ISPSEL"
                ></v-checkbox>
              </v-flex>
            </v-stepper-content>
            <!--Fine seconda scheda-->

            <!--Terza scheda - Regolarità e funzionalità dei dispositivi di protezione-->

            <v-stepper-content step="3">
              <v-flex d-flex xs12 sm12 md12 lg12 xl12 class="space-up">
                <v-textarea
                  outlined
                  label="Accessori di sicurezza"
                  v-model="verbale.accessoriSicurezza"
                  :rules="[rules.required]"
                ></v-textarea>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-textarea
                  outlined
                  label="Dispositivi di controllo"
                  v-model="verbale.dispositiviControllo"
                  :rules="[rules.required]"
                ></v-textarea>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-textarea
                  outlined
                  label="Dispositivi di regolazione"
                  v-model="verbale.dispositiviRegolazione"
                  :rules="[rules.required]"
                ></v-textarea>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-textarea
                  outlined
                  label="Altri accessori rilevanti"
                  v-model="verbale.altriAccessori"
                  :rules="[rules.required]"
                ></v-textarea>
              </v-flex>
            </v-stepper-content>
            <!--Fine terza scheda-->

            <!--Quarta scheda - Stato di conservazione-->
            <v-stepper-content step="4">
              <v-flex d-flex xs12 sm12 md12 lg12 xl12 class="space-up">
                <v-textarea
                  outlined
                  label="Lo stato di conservazione risulta"
                  v-model="verbale.statoConservazione"
                  :rules="[rules.required]"
                ></v-textarea>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12 class="space-up">
                <v-textarea
                  outlined
                  label="Osservazioni"
                  v-model="verbale.osservazioni"
                  :rules="[rules.required]"
                ></v-textarea>
              </v-flex>
            </v-stepper-content>
            <!--Fine quarta scheda-->

            <!--Quinta scheda - Esito della verifica -->
            <v-stepper-content step="5">
              <h4>In base a quanto rilevato lo</h4>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12 class="space-up">
                <v-col cols="6">
                  <v-checkbox
                    label="Stato funzionamento"
                    v-model="verbale.statofunz"
                  ></v-checkbox>
                </v-col>
                <v-col cols="6">
                  <v-checkbox
                    label="Stato conservazione"
                    v-model="verbale.statocons"
                  ></v-checkbox>
                </v-col>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 class="space-up">
                <v-select
                  label="del suddetto impianto/attrezzatua,"
                  outlined
                  :items="tipoEsito"
                  v-model="verbale.esito"
                  item-value="id"
                  item-text="name"
                  :rules="[rules.select]"
                  @change="verbale.motivoRifiuto = ''"
                ></v-select>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12 v-if="!esito">
                <v-text-field
                  label="Motivazione rifiuto"
                  v-model="verbale.motivoRifiuto"
                  outlined
                ></v-text-field>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-col xs6 sm6 md6 lg6 xl6>
                  <DataPicker
                    label="Data prossima verifica"
                    v-model="verbale.dataProssimaVerifica"
                    :rules="[rules.required]"
                    outlined
                  ></DataPicker>
                </v-col>
                <v-col xs6 sm6 md6 lg6 xl6>
                  <v-text-field
                    label="Luogo"
                    outlined
                    v-model="verbale.luogoVerifica"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-checkbox
                  v-model="verbale.updateScad"
                  label="Aggiorna dati sullo scadenziario"
                ></v-checkbox>
              </v-flex>
            </v-stepper-content>

            <v-stepper-content step="6">
              <v-flex
                xs12
                sm12
                md12
                lg12
                xl12
                class="space-up"
                v-if="numeroScheda == 6"
              >
                <h4>Firma cliente</h4>
                <VueSignaturePad
                  style="border: 1px solid #6c757d"
                  id="firmaDatore"
                  width="702px"
                  height="180px"
                  ref="firmaDatore"
                />
              </v-flex>
              <br />
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-btn color="error" @click="$refs.firmaDatore.clearSignature()"
                  >Cancella firma</v-btn
                >
              </v-flex>
              <br />
              <v-flex d-flex xs12 sm12 md12 lg12 xl12 v-if="false">
                <v-checkbox
                  label="Firma verificatore in affiancamento"
                  v-model="secondaFirma"
                  @change="resetSecondoVerificatore"
                ></v-checkbox>
              </v-flex>
              <br />
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-checkbox
                  label="Firma verificatore in affiancamento"
                  v-model="secondaFirma"
                  @change="resetSecondoVerificatore"
                ></v-checkbox>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12 v-if="secondaFirma">
                <v-select
                  label="Firma verificatore"
                  outlined
                  :items="listaVerificatori"
                  item-text="name"
                  item-value="ad_user_id"
                  v-model="verbale.ad_usersecondoverificatore_id"
                  no-data-text
                  :rules="[rules.select]"
                ></v-select>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12 v-if="secondaFirma">
                <v-select
                  label="Firma verificatore"
                  outlined
                  :items="listaVerificatori"
                  item-text="name"
                  item-value="ad_user_id"
                  v-model="verbale.ad_userterzoverificatore_id"
                  no-data-text
                ></v-select>
              </v-flex>
            </v-stepper-content>
          </v-form>
        </v-stepper-items>
      </v-stepper>
    </v-flex>
    <v-card mr-5>
      <v-footer fixed>
        <v-container>
          <v-flex d-flex>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="schedaPrecedente"
              :disabled="numeroScheda <= 1"
              >Indietro</v-btn
            >
            <v-btn
              v-if="numeroScheda < schedeTotali"
              color="primary"
              @click="schedaSuccessiva"
              >Avanti</v-btn
            >
            <v-btn
              v-else
              color="primary"
              @click="salvaVerbale"
              :disabled="saveDisabled || !form"
              >Salva</v-btn
            >
          </v-flex>
        </v-container>
      </v-footer>
    </v-card>
    <v-dialog v-model="dialogRiepilogo" width="60%" persistent>
      <v-card>
        <v-card-title>Riepilogo</v-card-title>
        <v-card-text>
          <v-simple-table>
            <thead>
              <th>Nome verbale</th>
              <th>Data verbale</th>
              <th>Data prossima verifica</th>
            </thead>
            <tbody>
              <tr>
                <td>{{ riepilogo.nomeVerbale }}</td>
                <td>{{ riepilogo.dataVerifica }}</td>
                <td>{{ riepilogo.dataProxVer }}</td>
              </tr>
            </tbody>
          </v-simple-table>
          <br>
          <v-alert type="warning" text v-if="isBadPayer" dense>
            Il cliente è un cattivo pagatore
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="home" text>Torna alla home</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog ref="confirm"></ConfirmDialog>
  </v-container>
</template>

<script>
/*eslint-disable  */
import DataPicker from "../components/DataPicker";
import ConfirmDialog from "../components/ConfirmDialog";
import editableTable from "../components/editableTable";

export default {
  components: {
    DataPicker,
    ConfirmDialog,
    editableTable,
  },
  data() {
    return {
      /*v-model*/
      verbale: {
        dataVerifica: new Date().toISOString().substr(0, 10),
        dataProssimaVerifica: new Date().toISOString().substr(0, 10),
        tipoVerifica: "",
        matricola: "",
        installatore: "",
        ditta: "",
        comuneDitta: "",
        viaDitta: "",
        matricoleVasi: "",
        rispettoIspesl: false,
        //numeroCivicoDitta: "",
        accessoriSicurezza: "",
        dispositiviControllo: "",
        dispositiviRegolazione: "",
        altriAccessori: "",
        statoConservazione: "",
        osservazioni:
          "Per l’uso e la manutenzione attenersi scrupolosamente all’indicazione de costruttore nel manuale uso e/o alle norme di buona tecnica",
        generatori: [],
        //tipoStatoVerifica: 0,
        fct_vergvrir_id: 0,
        luogoVerifica: "",
        ad_usersecondoverificatore_id: 0,
        ad_userverificatore_id: 0,
        esito: 1000002,
        statofunz: false,
        statocons: false,
        motivoRifiuto: "",
        updateScad: true,
      },
      headersGeneratori: [
        {
          text: "Tipo generatori",
          value: "tipo",
        },
        {
          text: "Costruttore",
          value: "costruttore",
        },
        {
          text: "Numero di Fabbrica",
          value: "nFab",
        },
        {
          text: "Pressione Max",
          value: "pressioneMax",
        },
        {
          text: "Tipo Combustibile",
          value: "tipoCombustibile",
        },
        {
          text: "Potenzialita Focolaio",
          value: "potenzialita",
        },
      ],
      numeroScheda: 1,
      schedeTotali: 6,
      secondaFirma: false,
      tipiVerifica: [],
      tipologiaMacchinario: [],
      tipoEsito: [],
      tipoStatoVerifica: [],
      listaVerificatori: [],
      firmaDatore: "",
      saveDisabled: false,
      form: true,
      rules: {
        required: (value) => (!!value ? true : "Campo richiesto!"),
        select: (value) => value != 0,
      },
      allowedDates: (val) => {
        let date = new Date(val);
        let dateO = new Date();
        dateO.setMonth(dateO.getMonth() - 1);
        return date.getTime() >= dateO.getTime();
      },
      allowedDatesProx: (val) => {
        let date = new Date(val);
        let dateV = new Date(this.verbale.dataVerifica);
        return date.getTime() >= dateV.getTime();
      },
      riepilogo: {},
      dialogRiepilogo: false,
      isBadPayer:false,
    };
  },
  methods: {
    schedaPrecedente() {
      if (this.numeroScheda > 1) {
        this.numeroScheda = parseInt(this.numeroScheda) - 1;
      }
    },
    schedaSuccessiva() {
      if (this.numeroScheda < this.schedeTotali) {
        this.numeroScheda = parseInt(this.numeroScheda) + 1;
      }
    },
    tornaAllaHome() {
      this.$router.push({ path: "/" });
    },
    resetSecondoVerificatore() {
      if (!this.secondaFirma) {
        this.verbale.ad_usersecondoverificatore_id = 0;
        this.verbale.ad_userterzoverificatore_id = 0;
      }
    },
    toISOStringUTC(datestr) {
      var tzoffset = new Date().getTimezoneOffset() * 60000;
      return new Date(new Date(datestr) - tzoffset).toISOString().slice(0, -1);
    },
    salvaVerbale() {
      if (!this.$refs.validForm.validate()) return;
      //this.saveDisabled = true;
      this.$store.commit("setProgressMessage", "Salvaggio verbale");
      this.$store.commit("setProgressLoading", true);
      let data = Object.assign({}, this.verbale);
      if (this.$refs.firmaDatore.isEmpty()) {
        data.firmaTitolareBase64 = null;
      } else {
        data.firmaTitolareBase64 = this.$refs.firmaDatore
          .saveSignature()
          .data.split(",")[1];
      }
      data.dataVerifica = this.toISOStringUTC(data.dataVerifica);
      data.dataProssimaVerifica = this.toISOStringUTC(
        data.dataProssimaVerifica
      );
      let parameters = {};
      parameters.data = data;
      parameters.idempiereRestPath = "vecos/aggiornaInserisciVerbaleGVRIR";
      console.log(data);
      this.$store.dispatch("callIdempiereRest", parameters).then(
        (response) => {
          console.log(response);
          if (response.data.fct_vergvrir_id != 0) {
            this.$store.commit("setProgressMessage", "Download in corso");
            var that = this;
            let item = response.data;
            console.log(item);
            let parameters = {};
            parameters.idempiereRestPath = "print/addPrintJob";
            let data = {};
            data.parameters = "{id:" + item.fct_vergvrir_id + "}";
            data.nomeStampa = "Verbale GVRIR";
            parameters.data = data;

            this.riepilogo.nomeVerbale = response.data.nomeVerbale;
            this.riepilogo.dataVerifica = response.data.dataVerbale;
            this.riepilogo.dataProxVer = response.data.dataProxVer;
            this.dialogRiepilogo = true;

            var that = this;
            setTimeout(function () {
              that.$store.commit("setProgressMessage", null);
            }, 1000);

            this.$store
              .dispatch("callIdempiereRest", parameters)
              .then((response) => {
                console.log(response);
                if (response.data.hasOwnProperty("file")) {
                  const linkSource =
                    "data:application/pdf;base64," + response.data.file;
                  const downloadLink = document.createElement("a");
                  const fileName = item.nomeVerbale + ".pdf";

                  downloadLink.href = linkSource;
                  downloadLink.download = fileName;
                  downloadLink.click();
                  setTimeout(function () {
                    that.$store.commit("setBozzaSP", null);
                    that.$store.commit("setProgressMessage", null);
                    that.$store.commit("setProgressLoading", true);
                    that.saveDisabled = false;
                    that.$store.commit("setBozzaSP", null);
                  }, 5000);
                } else {
                  this.$store.commit("setProgressMessage", null);
                  var errorMsg = "Stampa non riuscita";
                  if (response.data.hasOwnProperty("message")) {
                    errorMsg = errorMsg + "\n" + response.data.message;
                  }
                  this.$store.commit("setErrorMessage", errorMsg);
                }
              });
          } else {
            this.$store.commit("setProgressMessage", null);
            var errorMsg = "Salvataggio non riuscito";
            if (response.data.hasOwnProperty("message")) {
              errorMsg = errorMsg + "\n" + response.data.message;
            }
            this.$store.commit("setErrorMessage", errorMsg);
          }
        },
        (error) => {
          this.$store.commit("setProgressMessage", null);
          var errorMsg = "Salvataggio non riuscito";
          errorMsg = errorMsg + "\n" + error;
          this.$store.commit("setErrorMessage", errorMsg);
        }
      );
    },
    home() {
      this.$store.commit("setProgressMessage", null);
      this.$store.commit("setProgressLoading", true);
      this.saveDisabled = false;
      this.$router.push({ path: "/" });
    },
  },
  computed: {},
  mounted: async function () {
    this.$store.commit("setProgressMessage", "Caricamento dati macchina...");
    this.$vuetify.lang.current = "it";
    let data = {};
    data.type = "tipologiaMacchinarioGVR";
    let parameters = {};
    parameters.data = data;
    parameters.idempiereRestPath = "vecos/getVerbalOptions";
    await this.$store
      .dispatch("callIdempiereRest", parameters)
      .then((response) => {
        this.tipologiaMacchinario = response.data.opzioni;
      });
    parameters.data.type = "esito";
    await this.$store
      .dispatch("callIdempiereRest", parameters)
      .then((response) => {
        this.tipoEsito = response.data.opzioni;
      });
    parameters.data.type = "tipoVerificaGVRIR";
    await this.$store
      .dispatch("callIdempiereRest", parameters)
      .then((response) => {
        this.tipiVerifica = response.data.opzioni;
      });
    parameters.data.type = "tipoStatoVerificaGVR";
    await this.$store
      .dispatch("callIdempiereRest", parameters)
      .then((response) => {
        this.tipoStatoVerifica = response.data.opzioni;
      });
    parameters.data = {};
    parameters.idempiereRestPath = "vecos/getListaVerificatori";
    await this.$store
      .dispatch("callIdempiereRest", parameters)
      .then((response) => {
        this.listaVerificatori = response.data.listaVerificatori;
      });
    this.isBadPayer = this.$store.state.datiVerbale.isBadPayer;
    if (
      this.$store.state.datiVerbale.type == "C" ||
      this.$store.state.datiVerbale.type == "M"
    ) {
      data = {};
      data.fct_vergvrir_id = this.$store.state.datiVerbale.fct_vergvrir_id;
      parameters = {};
      parameters.data = data;
      parameters.idempiereRestPath = "vecos/getVerbaleGVRIR";
      await this.$store
        .dispatch("callIdempiereRest", parameters)
        .then((response) => {
          this.verbale = Object.assign({}, response.data.verbale);
          this.firmaDatore = this.verbale.firmaDatore;
          this.verbale.updateScad = true;
          delete this.verbale.firmaDatore;
          if (this.$store.state.datiVerbale.type == "C") {
            this.verbale.fct_vergvrir_id = 0;
            this.verbale.ad_usersecondoverificatore_id = 0;
            this.verbale.ad_userterzoverificatore_id = 0;
            this.firmaDatore = "";
            this.verbale.dataVerifica = new Date().toISOString().substr(0, 10);
            let dataProxVer = new Date();
            dataProxVer.setFullYear(dataProxVer.getFullYear() + 1);
            this.verbale.dataProssimaVerifica = dataProxVer
              .toISOString()
              .substr(0, 10);
            for (let index in this.verbale.generatori) {
              this.verbale.generatori[index].id_generatore = 0;
            }
            this.verbale.c_orderline_id = parseInt(
              this.$store.state.datiVerbale.c_orderline_id
            );
            this.verbale.fct_scadverifiche_id = parseInt(
              this.$store.state.datiVerbale.fct_scadverifiche_id
            );
            this.verbale.c_bpartner_id = parseInt(
              this.$store.state.datiVerbale.c_bpartner_id
            );
          } else {
            this.verbale.updateScad = false;
            this.verbale.fct_vergvrir_id = parseInt(
              this.$store.state.datiVerbale.fct_vergvrir_id
            );
            if (this.verbale.ad_usersecondoverificatore_id != 0) {
              this.secondaFirma = true;
            }
          }
        });
    } else {
      this.verbale.ad_userverificatore_id = this.$session.get("ad_user_id");
      data = {};
      data.fct_scadverifiche_id = this.$store.state.datiVerbale.fct_scadverifiche_id;
      parameters = {};
      parameters.data = data;
      parameters.idempiereRestPath = "vecos/getDatiMacchina";
      await this.$store
        .dispatch("callIdempiereRest", parameters)
        .then((response) => {
          let macchinario = response.data.macchinario;
          this.verbale.comuneDitta = macchinario.comuneDitta;
          this.verbale.ditta = macchinario.ditta;
          this.verbale.matricola = macchinario.matricolaInail;
          //this.verbale.numeroCivicoDitta = macchinario.numeroCivicoDitta;
          this.verbale.viaDitta = macchinario.viaDitta;
          this.verbale.luogoVerifica = macchinario.comuneDitta;
          this.verbale.certCE = macchinario.certCE;
        });
      this.verbale.dataVerifica = new Date().toISOString().substr(0, 10);
      let dataProxVer = new Date();
      dataProxVer.setFullYear(dataProxVer.getFullYear() + 1);
      this.verbale.dataProssimaVerifica = dataProxVer
        .toISOString()
        .substr(0, 10);
      this.verbale.fct_scadverifiche_id = parseInt(
        this.$store.state.datiVerbale.fct_scadverifiche_id
      );
      this.verbale.c_bpartner_id = parseInt(
        this.$store.state.datiVerbale.c_bpartner_id
      );
      this.verbale.c_orderline_id = parseInt(
        this.$store.state.datiVerbale.c_orderline_id
      );
      this.verbale.fct_vergvrir_id = 0;
    }
    this.$store.commit("setProgressMessage", null);
    if (
      this.$store.state.bozzaGVRIR != null &&
      this.$store.state.bozzaGVRIR.verbale.fct_vergvir_id ==
        this.$store.state.datiVerbale.fct_vergvrir_id &&
      this.$store.state.bozzaGVRIR.verbale.fct_scadverifiche_id ==
        this.verbale.fct_scadverifiche_id &&
      this.$store.state.datiVerbale.type == this.$store.state.bozzaGVRIR.type
    ) {
      this.$refs.confirm
        .open("Salvataggio", "Ripristinare il salvataggio automatico?", {
          color: "primary",
        })
        .then((confirm) => {
          if (confirm) {
            this.verbale = this.$store.state.bozzaGVRIR.verbale;
          } else {
            this.$store.commit("setBozzaGVRIR", null);
          }
          /*this.verbale.dataVerifica = new Date().toISOString().substr(0, 10);
          this.verbale.dataProssimaVerifica = new Date()
            .toISOString()
            .substr(0, 10);*/
        });
    } else {
      this.$store.commit("setBozzaGVRIR", null);
    }

    var that = this;
    setInterval(() => {
      let bozza = {};
      bozza.verbale = that.verbale;
      bozza.type = that.$store.state.datiVerbale.type;
      that.$store.commit("setBozzaGVRIR", bozza);
      console.log("salvataggio");
    }, 20000);
  },
  watch: {
    numeroScheda() {
      if (this.numeroScheda == this.schedeTotali && this.firmaDatore != "") {
        var that = this;
        setTimeout(function () {
          that.$refs.firmaDatore.fromDataURL(
            "data:image/png;base64," + that.firmaDatore
          );
        }, 10);
      }
    },
  },
  computed: {
    esito: function () {
      if (this.tipoEsito.length < 1) return false;
      for (let element of this.tipoEsito) {
        if (element.id == this.verbale.esito) {
          return element.name == "Risulta adeguato ai fini della sicurezza";
        }
      }
      return false;
    },
  },
};
</script>
<style>
.space-up {
  padding-top: 5px;
}
</style>
